var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedVolume = function SvgMedVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "med-volume_svg__Layer_1",
    width: 20,
    height: 20,
    strokeWidth: 1.5,
    color: "#24053b",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    role: "presentation"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5d6-1{fill:none;stroke:currentColor;stroke-miterlimit:10}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.83 10a2.84 2.84 0 0 1 0 4M17.84 8a5.7 5.7 0 0 1 0 8M1.5 8.21h4.74v7.58H1.5zM13.82 3.47v17.06h-1.66l-5.92-4.74V8.21l5.92-4.74z",
    className: "cls-6374f543b67f094e4896c5d6-1"
  })));
};
export default SvgMedVolume;